<div class="backspinner" *ngIf="mode === 'indeterminate'">
    <div class="spinner-border" role="status">
        <span class="sr-only">Loading...</span>
    </div>
</div>

<ng-container *ngIf="isSubmissionMode; else normalForm">
  <div class="row assessment-form">
    <div class="col-md-4"></div>
    <div class="col-md-4">
        <div class="register-form">
            <div class="popup-logo text-center">
                <!-- <a href="/"><img src="../../assets/images/leatherwood.png" alt="logo"></a> -->
                <h2>Points Submission Form</h2>
            </div>
            <form>
                <div class="form-group">
                    <label>First Name*</label>
                    <input type="text" id="firstName" name="firstName" [(ngModel)]="assessmentForm.firstName"
                        #firstName="ngModel" class="form-control" placeholder="john" />
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="firstNameError != ''" style="color:red">
                            {{firstNameError}}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Last Name*</label>
                    <input type="text" id="lastName" name="lastName" [(ngModel)]="assessmentForm.lastName"
                        #lastName="ngModel" placeholder="doe" class="form-control" />
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="lastNameError != ''" style="color:red">
                            {{lastNameError}}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Employee Id*</label>
                    <input type="text" id="empId" name="empId" [(ngModel)]="assessmentForm.empId"
                        #empId="ngModel" placeholder="doe" class="form-control" />
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="empIdError != ''" style="color:red">
                            {{empIdError}}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Email*</label>
                    <input type="text" id="email" name="email" [(ngModel)]="assessmentForm.email" #email="ngModel"
                        placeholder="email" class="form-control" />
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="emailError != ''" style="color:red">
                            {{emailError}}
                        </div>
                    </div>
                </div>
                <div class="form-group">
                    <label>Date of Exam*</label>
                    <input type="date" id="doe" name="doe" [(ngModel)]="assessmentForm.doe" #doe="ngModel"
                        placeholder="Date of exam" class="form-control"   [max]="todayDate"/>
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="doeError != ''" style="color:red">
                            {{doeError}}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">Exam Type*</label><br>
                    <select class="form-select" class="form-control" aria-label="Default select example"
                        (change)="checkPoints($event)">
                        <option value="">Select Exam Type</option>
                        <option *ngFor="let item of newAssessmentkeysLw" [value]="item.name">{{item.name}}{{" " +
                            item.point + " "}}Points</option>
                    </select>
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="activitiesError != ''" style="color:red">
                            {{activitiesError}}
                        </div>
                    </div>
                </div>

                <div class="form-group d-none" *ngIf="isRequiredFileUpload">
                    <label class="form-label">Upload File</label>
                    <input class="form-control form-control-lg" type="file" (change)="onFileSelected($event)">
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="fileError != ''" style="color:red">
                            {{fileError}}
                        </div>
                    </div>
                </div>

                <div class="form-group d-none" *ngIf="!isRequiredFileUpload">
                    <label class="form-label">Upload File</label>
                    <input class="form-control form-control-lg" type="file" (change)="onFileSelected($event)">
                </div>

                <div class="form-group text-center submit-btn">
                    <button type="button" (click)="submitLwForm()" class="btn btn-primary">Submit</button>
                </div>
                <div>
                    <h4 *ngIf="responseMessage != ''" style="color: red; text-align:center;">{{responseMessage}}</h4>
                </div>
            </form>
        </div>
    </div>
    <div class="col-md-4"></div>
</div>
</ng-container>

<ng-template #normalForm>
    
<div class="row assessment-form">
    <div class="col-md-4"></div>
    <div class="col-md-4">
        <div class="register-form">
            <div class="popup-logo text-center">
                <a href="/"><img src="../../assets/images/nar.png" alt="logo"></a>
                <h2>NAR Activity Points Submission Form</h2>
            </div>
            <form>
                <div class="form-group">
                    <label>First Name*</label>
                    <input type="text" id="firstName" name="firstName" [(ngModel)]="assessmentForm.firstName"
                        #firstName="ngModel" class="form-control" placeholder="john" />
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="firstNameError != ''" style="color:red">
                            {{firstNameError}}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Last Name*</label>
                    <input type="text" id="lastName" name="lastName" [(ngModel)]="assessmentForm.lastName"
                        #lastName="ngModel" placeholder="doe" class="form-control" />
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="lastNameError != ''" style="color:red">
                            {{lastNameError}}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label>Email*</label>
                    <input type="text" id="email" name="email" [(ngModel)]="assessmentForm.email" #email="ngModel"
                        placeholder="email" class="form-control" />
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="emailError != ''" style="color:red">
                            {{emailError}}
                        </div>
                    </div>
                </div>

                <div class="form-group">
                    <label class="form-label">Activities*</label><br>
                    <select class="form-select" class="form-control" aria-label="Default select example"
                        (change)="checkPoints($event)">
                        <option value="">Select Activity</option>
                        <option *ngFor="let item of newAssessmentkeys" [value]="item.name">{{item.name}}{{" " +
                            item.point + " "}}Points</option>
                    </select>
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="activitiesError != ''" style="color:red">
                            {{activitiesError}}
                        </div>
                    </div>
                </div>

                <div class="form-group" *ngIf="isRequiredFileUpload">
                    <label class="form-label">Upload File*</label>
                    <input class="form-control form-control-lg" type="file" (change)="onFileSelected($event)">
                    <div *ngIf="submitted" class="invalid-feedback">
                        <div *ngIf="fileError != ''" style="color:red">
                            {{fileError}}
                        </div>
                    </div>
                </div>

                <div class="form-group" *ngIf="!isRequiredFileUpload">
                    <label class="form-label">Upload File</label>
                    <input class="form-control form-control-lg" type="file" (change)="onFileSelected($event)">
                </div>

                <div class="form-group text-center submit-btn">
                    <button type="button" (click)="submitForm()" class="btn btn-primary">Submit</button>
                </div>
                <div>
                    <h4 *ngIf="responseMessage != ''" style="color: red; text-align:center;">{{responseMessage}}</h4>
                </div>
            </form>
        </div>
    </div>
    <div class="col-md-4"></div>
</div>
</ng-template>

